import type { IRowData } from '../types/offer.types';

type RowInlineState = {
  localPrice: number | null;
  localDiscount: number | null;
  localOfferGroupId?: string | null;
  localOfferGroupName?: string | null;
};

export const applyInlineOfferStateToRow = (rowData: IRowData, rowState?: RowInlineState): IRowData => {
  if (!rowState) return rowData;

  const updatedRowData = {
    ...rowData,
    offer_final_price: rowState.localPrice ?? rowData.offer_final_price,
    offer_discount_percentage: rowState.localDiscount ?? rowData.offer_discount_percentage,
    offer_group_id: rowState.localOfferGroupId ?? rowData.offer_group_id,
    offer_group: rowState.localOfferGroupName ?? rowData.offer_group,
  };

  if (!updatedRowData.offer_dto?.offer) return updatedRowData;

  const offerType = updatedRowData.offer_dto.offer.offer_type;
  const newOffer = { ...updatedRowData.offer_dto.offer };

  if (offerType === 'SIMPLE_PRICE' && rowState.localPrice !== null) {
    newOffer.offer_price = rowState.localPrice;
  } else if (offerType === 'SIMPLE_PERCENTAGE' && rowState.localDiscount !== null) {
    newOffer.percentage_discount = rowState.localDiscount;
  } else if (offerType === 'FROM_TO' && rowState.localPrice !== null) {
    newOffer.to = rowState.localPrice;
  } else if (offerType === 'BUY_GET_DISCOUNT' && rowState.localDiscount !== null) {
    newOffer.percentage_discount = rowState.localDiscount;
  } else if (offerType === 'UNIT_DISCOUNT' && rowState.localDiscount !== null) {
    newOffer.percentage_discount = rowState.localDiscount;
  } else if (offerType === 'BULK_PERCENTAGE' && rowState.localDiscount !== null) {
    newOffer.percentage_discount = rowState.localDiscount;
  } else if (offerType === 'BULK_PRICE' && rowState.localPrice !== null) {
    newOffer.price_per_unit = rowState.localPrice;
  }

  updatedRowData.offer_dto = {
    ...updatedRowData.offer_dto,
    offer: newOffer,
  };

  return updatedRowData;
};
